import React, { useState } from "react";


  const Counter = () => {

    const [counterProject, setCounterProject] = useState(0)
    
    const buttonClick1 = () => {
      setCounterProject(counterProject + 1)
    }
    
    const buttonClick2 = () => {
      if (counterProject > 0) {
        setCounterProject(counterProject - 1)
      }
      

    }
    
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '300%',
        position: 'center',
        border: '200px',
        borderColor: 'solid black',
        width: '100%',
        height: '100%',
        top: '-15%',
      }}>
        Cookies for a Mouse 
        <div style={{
          fontSize: '120%',
          position: 'relative',
          top: '10vh',
        }}>
          {counterProject}
        </div>
        <div className="buttons">
          <button style={{
            fontSize: '60%',
            position: 'relative',
            top: '20vh',
            marginRight: '5px',
            backgroundColor: 'black',
            color: 'white',
          }}
            onClick={buttonClick1}>Give One</button>
          <button style={{
            fontSize: '60%',
            position: 'relative',
            top: '20vh',
            marginLeft: '5px',
            backgroundColor: 'blue',
            color: 'white',
          }}
            onClick={buttonClick2}>Take One</button>
        </div>
      </div>
    )
  }
    
  export default Counter;

